import { render, staticRenderFns } from "./ProductSearchCard.vue?vue&type=template&id=4b1b0218&scoped=true&"
import script from "./ProductSearchCard.vue?vue&type=script&lang=js&"
export * from "./ProductSearchCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchCard.vue?vue&type=style&index=0&id=4b1b0218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b0218",
  null
  
)

export default component.exports